/*
 * @Author: Yun
 * @Date: 2023-12-11 10:53:14
 * @Last Modified by: Yun
 * @Last Modified time: 2023-12-28 12:56:40
 */
import React from 'react'
import './index.less'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper/core'

const PREFIX = 'bottom-page'

const BottomPage = (props) => {
    return (
        <div className="bottom-page-mobile">
            <div className="bottom-page-title"></div>
            <div className="history-wrapper">
                <Swiper
                    loop={true}
                    slidesPerView={4}
                    centeredSlides={true}
                    spaceBetween={10}
                    // pagination={true}
                    // onSwiper={(swiper) => onSwiper(swiper)}
                    // onSlideChangeEnd={onSlideChangeEnd()}
                >
                    <SwiperSlide>
                        <div className="history-item-wrapper">
                            <a href="https://cp.cgtn.com/2016/" target="_blank">
                                <div className="history-1 history-item"></div>
                                <div className="year">2016</div>
                            </a>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="history-item-wrapper">
                            <a href="https://cp.cgtn.com/index.html" target="_blank">
                                <div className="history-2 history-item"></div>
                                <div className="year">2017</div>
                            </a>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="history-item-wrapper">
                            <a
                                href="https://news.cgtn.com/event/2018/China2018/index.html"
                                target="_blank"
                            >
                                <div className="history-3 history-item"></div>
                                <div className="year">2018</div>
                            </a>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="history-item-wrapper">
                            <a
                                href="https://news.cgtn.com/event/2019/China2019/index.html"
                                target="_blank"
                            >
                                <div className="history-4 history-item"></div>
                                <div className="year">2019</div>
                            </a>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="history-item-wrapper">
                            <a
                                href="https://news.cgtn.com/event/2020/decisiveyear/index.html"
                                target="_blank"
                            >
                                <div className="history-5 history-item"></div>
                                <div className="year">2020</div>
                            </a>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="history-item-wrapper">
                            <a
                                href="https://news.cgtn.com/event/2021/China2021/index.html"
                                target="_blank"
                            >
                                <div className="history-6 history-item"></div>
                                <div className="year">2021</div>
                            </a>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="history-item-wrapper">
                            <a
                                href="https://news.cgtn.com/event/2022/China2022/index.html"
                                target="_blank"
                            >
                                <div className="history-7 history-item"></div>
                                <div className="year">2022</div>
                            </a>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="history-item-wrapper">
                            <a
                                href="https://news.cgtn.com/event/2023/China2023/index.html"
                                target="_blank"
                            >
                                <div className="history-8 history-item"></div>
                                <div className="year">2023</div>
                            </a>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
        </div>
    )
}

export default BottomPage
